const BASE_URL = {
  local: 'http://localhost:8080/',
  dev: 'https://bln.dev.bdn.fr/ws/',
  uat: 'https://bln.uat.bdn.fr/ws/',
  prod: 'https://bln.bdn.fr/ws/',
}

const GRAPHQL_URLS = {
  local: 'http://localhost:8080/graphql',
  dev: 'https://bln.dev.bdn.fr/graphql',
  uat: 'https://bln.uat.bdn.fr/graphql',
  prod: 'https://bln.bdn.fr/graphql',
}

const { REACT_APP_INFRA = 'uat', REACT_APP_PREFIX = '' } = process.env
const API_BASE_URL = BASE_URL[REACT_APP_INFRA]
const GRAPHQL_URL = GRAPHQL_URLS[REACT_APP_INFRA]

export default {
  API_BASE_URL,
  REACT_APP_PREFIX,
  GRAPHQL_URL,
}
